export default __webpack_public_path__ + "locales/si/Common.json?hash=4cfcd324464d2294fc6c8555716fc303";